<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card>
    <div class="p-fluid lk-eu-mobile-form-fields">
      <div class="field">
        <label class="font-medium required-field">Дата проезда</label>
        <crm-datepicker
          filtersUiVersion="v2"
          [(value)]="task.date"
          [inputStyleClass]="errors?.date ? 'ng-invalid ng-dirty' : ''"
          appendTo="body"></crm-datepicker>
        <small
          *ngIf="errors?.date"
          class="p-error">
          {{ errors?.date | join }}
        </small>
      </div>

      <p-messages
        *ngIf="!(form$ | async)?.isShowDelete"
        severity="info">
        <ng-template pTemplate="">
          <div class="flex gap-2 align-items-center">
            <i
              class="pi pi-exclamation-circle"
              style="font-size: 1.3rem"></i>
            <ul [style.padding-inline-start.px]="20">
              <li>Введите только регистрационный номер транспортного средства</li>
              <li>Пример: А001МР97</li>
            </ul>
          </div>
        </ng-template>
      </p-messages>

      <div class="field">
        <label class="font-medium required-field">Гос. номер ТС</label>
        <crm-input-text
          [(value)]="task.carNumber"
          [isError]="$any(errors?.carNumber)"></crm-input-text>
        <small
          *ngIf="errors?.carNumber"
          class="p-error">
          {{ errors.carNumber | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Помещения</label>
        <crm-personal-account-room-multi-select
          [isError]="$any(errors?.rooms)"
          [(selectedRooms)]="task.rooms"
          [isFloatLabel]="false"
          [autoSelectOne]="true"
          (selectedRoomsChange)="onRoomsChange($event)"
          appendTo="body">
        </crm-personal-account-room-multi-select>
        <small
          *ngIf="errors?.rooms"
          class="p-error">
          {{ errors.rooms | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Категория ТС</label>
        <crm-personal-account-car-category-single-select
          [isError]="$any(errors?.category)"
          [roomIds]="categoryFilterRoomIds"
          [disabled]="!task.rooms?.length"
          [placeholder]="!task.rooms?.length ? 'Выберите помещения' : '\u00A0'"
          [(selectedCategory)]="task.category"
          appendTo="body">
        </crm-personal-account-car-category-single-select>
        <small
          *ngIf="errors?.category"
          class="p-error">
          {{ errors.category | join }}
        </small>
      </div>
    </div>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveTask()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
